import { css } from '@emotion/css';
import { DialogContent, DialogContentProps } from '@material-ui/core';
import React from 'react';

export const DialogContentWithoutPadding = ({
  fullHeight,
  ...props
}: DialogContentProps & { fullHeight?: boolean }) => {
  return (
    <DialogContent
      {...props}
      classes={{
        ...props.classes,
        root: css({
          paddingTop: '0 !important', // MUI overrides this when it's the first-child, we don't want that
          paddingBottom: '0 !important',
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
          height: fullHeight ? '100vh' : undefined
        })
      }}
    />
  );
};
